import { getNamePartOrBlank } from "./getNamePartOrBlank";

export const getFirstNameOrBlank = (text: unknown) => getNamePartOrBlank(text, "first");